import {useState, useRef, useEffect} from 'react'
import styled from 'styled-components'
import {BsThreeDots} from 'react-icons/bs'

interface MenuItem {
	label: string
	onClick: () => void
	danger?: boolean
}

interface Props {
	items: MenuItem[]
}

const BookDetailMenuButton = ({items}: Props) => {
	const [isOpen, setIsOpen] = useState(false)
	const menuRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
				setIsOpen(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	return (
		<Container ref={menuRef}>
			<MenuButton onClick={() => setIsOpen(!isOpen)}>
				<BsThreeDots/>
			</MenuButton>

			{isOpen && (
				<Dropdown>
					{items.map((item, i) => (
						<DropdownItem
							key={i}
							$danger={item.danger}
							onClick={() => {
								setIsOpen(false)
								item.onClick()
							}}
						>
							{item.label}
						</DropdownItem>
					))}
				</Dropdown>
			)}
		</Container>
	)
}

const Container = styled.div`
	position: relative;
`

const MenuButton = styled.button`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: none;
	background: transparent;
	color: var(--primary-color);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	font-size: 22px;

	&:hover {
		background-color: var(--hover-bg-color);
	}
`

const Dropdown = styled.div`
	position: absolute;
	top: 36px;
	right: 0;
	background-color: var(--card-bg-color);
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	border: 1px solid rgba(0, 0, 0, 0.08);
	min-width: 160px;
	padding: 6px 0;
	z-index: 100;
`

const DropdownItem = styled.button<{$danger?: boolean}>`
	width: 100%;
	padding: 10px 16px;
	border: none;
	background: transparent;
	text-align: left;
	cursor: pointer;
	font-size: 15px;
	color: ${({$danger}) => $danger ? 'var(--danger)' : 'var(--text-color)'};

	&:hover {
		background-color: var(--hover-bg-color);
	}
`

export default BookDetailMenuButton
